var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("overview")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.ShowAllInOverview"),
                            },
                            model: {
                              value: _vm.config.ShowAllInOverview,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "ShowAllInOverview", $$v)
                              },
                              expression: "config.ShowAllInOverview",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.AutoCalculateCosts"),
                            },
                            model: {
                              value: _vm.config.AutoCalculateCosts,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "AutoCalculateCosts", $$v)
                              },
                              expression: "config.AutoCalculateCosts",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.AddCostFromDayOne"),
                            },
                            model: {
                              value: _vm.config.AddCostFromDayOne,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "AddCostFromDayOne", $$v)
                              },
                              expression: "config.AddCostFromDayOne",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.ReminderFromExpiration"),
                            },
                            model: {
                              value: _vm.config.ReminderFromExpiration,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "ReminderFromExpiration",
                                  $$v
                                )
                              },
                              expression: "config.ReminderFromExpiration",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("labels.AddCreditNotes") },
                            model: {
                              value: _vm.config.AddCreditNotes,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "AddCreditNotes", $$v)
                              },
                              expression: "config.AddCreditNotes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("labels.IncludeSalesInReminder"),
                            },
                            model: {
                              value: _vm.config.IncludeSales,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "IncludeSales", $$v)
                              },
                              expression: "config.IncludeSales",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "labels.IncludeSalesInReminderForPrint"
                              ),
                            },
                            model: {
                              value: _vm.config.IncludeSalesForPrint,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "IncludeSalesForPrint",
                                  $$v
                                )
                              },
                              expression: "config.IncludeSalesForPrint",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("labels.PrintAfterSend") },
                            model: {
                              value: _vm.userConfig.PrintReminderAfterSend,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.userConfig,
                                  "PrintReminderAfterSend",
                                  $$v
                                )
                              },
                              expression: "userConfig.PrintReminderAfterSend",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("labels.Intrests"),
                            },
                            model: {
                              value: _vm.config.Intrests,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "Intrests", $$v)
                              },
                              expression: "config.Intrests",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("labels.AdminCostFrom"),
                            },
                            model: {
                              value: _vm.config.AdminCostFrom,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "AdminCostFrom", $$v)
                              },
                              expression: "config.AdminCostFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("labels.BccAddress"),
                            },
                            model: {
                              value: _vm.config.BccAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "BccAddress", $$v)
                              },
                              expression: "config.BccAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("costs")))]),
              _c(
                "w-card-content",
                { style: { padding: 0 } },
                [
                  _c("app-custom-table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticStyle: { width: "25px" } }, [
                          _vm._v(" " + _vm._s(_vm.$ct("reminder")) + " "),
                        ]),
                        _c("th", { staticStyle: { width: "85px" } }, [
                          _vm._v(" " + _vm._s(_vm.$ct("cost")) + " EUR "),
                        ]),
                        _c("th", { staticStyle: { width: "85px" } }, [
                          _vm._v(" " + _vm._s(_vm.$ct("cost")) + " % "),
                        ]),
                      ]),
                    ]),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [_vm._v(_vm._s(_vm.$ct("reminder")) + " 1")]),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "EUR" },
                              model: {
                                value: _vm.config.HCost1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HCost1", $$v)
                                },
                                expression: "config.HCost1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "%" },
                              model: {
                                value: _vm.config.HPerc1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HPerc1", $$v)
                                },
                                expression: "config.HPerc1",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v(_vm._s(_vm.$ct("reminder")) + " 2")]),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "EUR" },
                              model: {
                                value: _vm.config.HCost2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HCost2", $$v)
                                },
                                expression: "config.HCost2",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "%" },
                              model: {
                                value: _vm.config.HPerc2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HPerc2", $$v)
                                },
                                expression: "config.HPerc2",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v(_vm._s(_vm.$ct("reminder")) + " 3")]),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "EUR" },
                              model: {
                                value: _vm.config.HCost3,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HCost3", $$v)
                                },
                                expression: "config.HCost3",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "%" },
                              model: {
                                value: _vm.config.HPerc3,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HPerc3", $$v)
                                },
                                expression: "config.HPerc3",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v(_vm._s(_vm.$ct("reminder")) + " 4")]),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "EUR" },
                              model: {
                                value: _vm.config.HCost4,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HCost4", $$v)
                                },
                                expression: "config.HCost4",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("w-input-number", {
                              attrs: { fancy: "", label: "%" },
                              model: {
                                value: _vm.config.HPerc4,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "HPerc4", $$v)
                                },
                                expression: "config.HPerc4",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-settings-automation", {
            staticClass: "mt",
            model: {
              value: _vm.config,
              callback: function ($$v) {
                _vm.config = $$v
              },
              expression: "config",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }